import React from "react";
import { useDispatch } from "react-redux";
import TemplateLayout from "../../../../../providers/TemplateLayout";
import { setTemplateText } from "../../../../../store/slices/endorsement.slice";
import { useAppSelector } from "../../../../../hooks/app";
import { getUser } from "../../../../../store/slices/auth-slice";
import { ROLES } from "../../../../../constants";

function SoloFlightFive({ templateName }: { templateName: string }) {
  const user = useAppSelector(getUser)
  const [name, setName] = React.useState(user?.role === ROLES.STUDENT ? user?.firstname + " " + user?.lastname : '')
  const [flightOperationsLocation, setFlightOperationsLocation] = React.useState("");
  const [limitations, setLimitations] = React.useState("");
  const dispatch = useDispatch();

  React.useEffect(() => {
    const templateText = `I certified that ${name} has received the required training of §61.95(b)(1). I have determined that [he or she] is proficient to conduct solo flight operations at ${flightOperationsLocation}. Limitations §61.89(a)(8): ${limitations}`;
    dispatch(setTemplateText(templateText));
  }, [name, flightOperationsLocation, limitations, dispatch]);

  return (
    <TemplateLayout templateName={templateName}>
      <div className="col-12 my-2">
        <label>Relevant FAR: 61.101(g)</label>
      </div>

      <div className="col-12 my-2">
        <p className="certificate_text" style={{ margin: 0 }}>
          I certified that{" "}
          <input type="text" onChange={(e) => setName(e.target.value)} value={name} /> has received the required training of §61.95(b)(1). I have determined that [he or she] is proficient to conduct solo flight operations at
          <select
            onChange={(e) => setFlightOperationsLocation(e.target.value)}
            style={{ margin: '0 5px' }}
          >
            <option>Select</option>
          </select>
          . Limitations §61.89(a)(8):
          <input
            type="text"
            onChange={(e) => setLimitations(e.target.value)}
            className="input_long"
            style={{ margin: '0 5px' }}
          />
        </p>
      </div>
    </TemplateLayout>
  );
}

export default SoloFlightFive;